<template>
   
    <form @submit.prevent="verifyOtp">
        <div class="form-group">
            <label for="otp">Enter OTP</label>
            <input type="text" class="form-control" v-model="otp"  placeholder="OTP" required>
            <span class="error d-block mt-2" v-if="errors">{{errors}}</span>
        </div>
        <div class="form-group text-end">
            <button @click="reSendOTP" id="resend-otp" class="btn-resend" :disabled="resendDisabled" type="button">ReSend OTP</button>
        </div>
        <div class="form-group text-center mt-4 mb-3">
            <button id="submit-otp" class="btn btn-button d-inline-block" type="submit">Verify OTP</button>
        </div>
         <div class="form-group text-center">
            <span v-if="countdown > 0 && resendDisabled">Resend OTP in {{ countdown }} seconds</span>
        </div>
    </form>
    
</template>

<script>
    export default {
        beforeMount() {
            this.updateCsrfToken();
        },
        name: "otp",

        data() {
            return {
                otp: '',
                resendDisabled: false,
                countdown: 5,
                errors: null,
            };
        },
        mounted() {
            this.startCountdown();
        },
        methods: {
            startCountdown() {
                this.resendDisabled = true;
                let timer = setInterval(() => {
                    if (this.countdown > 0) {
                        this.countdown--;
                    } else {
                        this.resendDisabled = false;
                        clearInterval(timer);
                        this.countdown = 5;
                        this.updateCsrfToken();
                    }
                }, 1000);
            },
            reSendOTP() {
                const self = this;
                axios.post('api/auth/resend-otp', {
                    otp: this.otp,
                })
                    .then(response => {
                        self.$store.commit('login', response.data);
                        self.$router.push('/modules/home');
                    })
                    .catch(error => {
                        console.error(error);
                    });
                this.startCountdown();
            },
            updateCsrfToken() {
                axios.get('/api/csrf-token')
                    .then(response => {
                        const csrfToken = response.data.csrf_token;
                        const metaTag = document.querySelector('meta[name="csrf-token"]');
                        metaTag.setAttribute('content', csrfToken);
                    })
                    .catch(error => {
                        // Handle error
                    });
            },
            verifyOtp() {
                this.errors =null;
                const self = this;
                axios.post('api/auth/verify-otp', {
                    otp: this.otp,
                })
                    .then(response => {
                       
                        if(response.data.status=='false'){
                            this.errors = response.data.message
                        }else{
                            self.$store.commit('login', response.data);
                            self.$router.push('/modules/home');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
        },
    }
</script>